export enum AGRMDataType {
    General = 'general',
    Orchestrations = 'orchestrations',
    States = 'states',
}
